var AbstractConnectionController = require("connect/AbstractConnectionController");
var Utils = require("common/Utils");

function ConnectionController() {
    AbstractConnectionController.call(this);

    var self = this;

    // When the user has been logged out, force a reconnection to the server to
    // fetch any updated config and let it redirect to the logon view
    $(document).on("userunauthenticated", function() {
        self.showView(self.getViews()[0]);
    });
}

Utils.inherits(ConnectionController, AbstractConnectionController);

module.exports = ConnectionController;


//////////////////
// WEBPACK FOOTER
// ./connect/ConnectionController.js
// module id = 30
// module chunks = 0 3